export default __webpack_public_path__ + "./ico-courses-enrolled-on.b9e639e046e05807b550f1940357bac5.png";